import { SequencedSamplesSeries } from './sequenced-samples.types';
import { DropdownItem } from '@base-app';
import {
  DemographicsData,
  GroupedDemographicsData,
} from '../components/CollectionAndSequencing/Demographics/Demographics.types';

export enum DemographicsSerieStatus {
  AWAITING = 'AWAITING',
  RECEIVED = 'RECEIVED',
  IN_SEQUENCING = 'IN_SEQUENCING',
  SEQUENCING_COMPLETE = 'SEQUENCING_COMPLETE',
  RECOLLECT = 'RECOLLECT',
  RESULTS_DELIVERED = 'RESULTS_DELIVERED',
  VALID = 'VALID',
}

export interface DemographicsParam {
  endDate?: string;
  startDate?: string;
  studyId?: string;
  sampleStatus: DemographicsSerieStatus[];
}

export interface DemographicsResponse {
  byRaceEthnicity: SequencedSamplesSeries[];
  byPreferredLanguage: SequencedSamplesSeries[];
  byAgeRange: SequencedSamplesSeries[];
  byBiologicalSex: SequencedSamplesSeries[];
}

export interface UseDemographicsFiltersProps {
  data: DemographicsData;
  selectedPillId: string;
}

export interface UseDemographicsFilters {
  handleFilterChange: (item: DropdownItem) => void;
  reducedData: GroupedDemographicsData;
  isFilteringData: boolean;
}
